import { Platfrom } from './PlatformConstants';

function isWeixin() {
  const ua = navigator.userAgent.toLowerCase();
  if (ua.includes('wechat') || ua.includes('micromessenger') || ua.includes('MicroMessenger')) {
    return true;
  } else {
    return false;
  }
}

function isQQ() {
  const ua = navigator.userAgent.toLowerCase();
  if (ua.includes('qq/')) {
    return true;
  } else {
    return false;
  }
}

function isWeibo() {
  const ua = navigator.userAgent.toLowerCase();
  if (ua.includes('weibo')) {
    return true;
  } else {
    return false;
  }
}

function isUnsupportOpen() {
  if (isIOS()) {
    return isQQ() || isWeibo();
  } else {
    return isWeixin() || isQQ() || isWeibo();
  }
}

function isUnsupportDownload() {
  return isWeixin() || isQQ() || isWeibo();
}

// 检查客户端
function getPlatform() {
  const isIOS = real_isIOS();
  const isHarmonyOS = /OpenHarmony/.test(navigator.userAgent);
  const isWpsClient = window && !!window.wpsQuery; // wps pc客户端
  if (isWpsClient) {
    return Platfrom.PC;
  } else if (isIOS) {
    return Platfrom.IOS;
  } else if (isHarmonyOS) {
    return Platfrom.HARMONYOS;
  } else {
    return Platfrom.ANDROID;
  }
}

function real_isIOS() {
  const ua = navigator.userAgent;
  const isIOSDevice = /iP(hone|ad)/.test(ua);
  const isMacLike = /Macintosh/.test(ua);
  const hasTouch = 'ontouchend' in document;
  //iPadOS 13+ 会伪装成 Mac，需要进一步判断：利用 Macintosh + 触摸屏 来判断 iPadOS
  return isIOSDevice || (isMacLike && hasTouch);
}

function isAndroid() {
  return getPlatform() === Platfrom.ANDROID;
}

function isIOS() {
  return getPlatform() === Platfrom.IOS;
}

function isPC() {
  return getPlatform() === Platfrom.PC;
}

function isHarmony() {
  return getPlatform() === Platfrom.HARMONYOS;
}

export default {
  isWeixin,
  isQQ,
  isWeibo,
  getPlatform,
  isAndroid,
  isIOS,
  isPC,
  isHarmony,
  isUnsupportOpen,
  isUnsupportDownload,
};
